module.exports = __webpack_public_path__ + "img/115.ddd3b19.jpg";